import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAdminAuth } from "../../hooks/useAdmin";
import { AdminRoleProvider } from "../../hooks/useAdminRole";
import Loading from "../Shared/Loading/Loading";

const RequireAdmin = ({ children }) => {
  const { user, loading, isAdmin, isSuperAdmin, role } = useAdminAuth();
  const location = useLocation();

  if (loading) return <Loading />;
  if (!user)
    return <Navigate to="/login" state={{ from: location }} replace />;
  if (!isAdmin) return <Navigate to="/dashboard" replace />;

  return (
    <AdminRoleProvider value={{ role, isSuperAdmin }}>
      {children}
    </AdminRoleProvider>
  );
};

export default RequireAdmin;
